interface IOptions {
    label: string;
    value: string;
}

export const DemographicGroupList: Array<IOptions> = [
    {
        label: 'African Male',
        value: '1_1',
    },
    {
        label: 'African Female',
        value: '1_2',
    },
    {
        label: 'Coloured Male',
        value: '2_1',
    },
    {
        label: 'Coloured Female',
        value: '2_2',
    },
    {
        label: 'Indian Male',
        value: '3_1',
    },
    {
        label: 'Indian Female',
        value: '3_2',
    },
    {
        label: 'White Male',
        value: '4_1',
    },
    {
        label: 'White Female',
        value: '4_2',
    },
];

export const DemographicGroupListWithNone: Array<IOptions> = [
    {
        label: 'None',
        value: '',
    },
    ...DemographicGroupList,
];

export const DemographicGroupListWithForeignNationals: Array<IOptions> = [
    ...DemographicGroupList,
    {
        label: 'Foreign National Male',
        value: '5_1',
    },
    {
        label: 'Foreign National Female',
        value: '5_2',
    },
];
